module.exports = __webpack_public_path__ + "img/_ico.e4bf886b.svg";